import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import apiRequest from "../../lib/http"
import { businessTimeZone } from "../../utils/date"
import { normalizeError } from "../../utils/errorHelpers"


export const fetchContactsReq = createAsyncThunk('customer/fetchContactsReq', async ({
                                                                                       limit,
                                                                                       offset,
                                                                                       filters,
                                                                                       searchQuery,
                                                                                       leads,
                                                                                       byCreator,
                                                                                       sortField = '',
                                                                                       sortOrder = '',
                                                                                       dispositionView,
                                                                                     }, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get('/customUsers', {
      params: {
        limit,
        offset,
        filters: result === "%22%22" ? "" : result,
        searchQuery,
        leads,
        byCreator,
        sortField,
        sortOrder,
        timezone: businessTimeZone,
        ...(dispositionView ? { dispositionView } : {}),
      }
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contacts'
    return rejectWithValue(errorMessage)
  }
})

export const getFilters = createAsyncThunk('customer/getFilters', async ({ flow }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/filters?flow=${flow}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const createFilterList = createAsyncThunk('filters/createFilterList', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post('/filters-lists', data)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create the filter list'
    return rejectWithValue(errorMessage)
  }
})

export const getFilterList = createAsyncThunk('filters/getFilterList', async ({ flow }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/filters-lists/${flow}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch filters'
    console.error('getFilterList error:', errorMessage)
    return rejectWithValue(errorMessage)
  }
})

export const getContactByFilterList = createAsyncThunk('customer/getContactByFilterList',
  async ({
           limit,
           offset,
           filterListId,
           searchQuery,
           leads,
           byCreator,
           sortField,
           sortOrder,
           dispositionView,
         }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/customUsers/filters/${filterListId}`, {
        params: {
          limit,
          offset,
          searchQuery,
          leads,
          byCreator,
          sortField,
          sortOrder,
          timezone: businessTimeZone,
          ...(dispositionView ? { dispositionView } : {}),
        }
      })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contacts'
      return rejectWithValue(errorMessage)
    }
  }
)

export const createCustomUser = createAsyncThunk('customer/contacts', async (userData, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post('/customUsers', userData)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create custom user'
    return rejectWithValue(errorMessage)
  }
})
export const importCustoms = createAsyncThunk('customer/contacts', async (userData, { rejectWithValue }) => {
  try {
    const formData = new FormData()
    formData.append("file", userData.file, userData.file.name)
    formData.append("type", userData.type)
    const response = await apiRequest.post('/customUsers/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to import contacts'
    return rejectWithValue(errorMessage)
  }
})

export const changeStatus = createAsyncThunk('admin/changeStatus', async ({
                                                                            userId,
                                                                            statusId,
                                                                            confirm,
                                                                            reason
                                                                          }, { rejectWithValue }) => {
  try {
    const url = `/customUsers/${userId}/statuses/${statusId}`
    const response = confirm !== undefined || reason !== undefined
      ? await apiRequest.put(url, { confirm, reason })
      : await apiRequest.put(url)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to change status'
    return rejectWithValue(errorMessage)
  }
})

export const getStatusChangeImpact = createAsyncThunk('admin/getStatusChangeImpact', async ({
                                                                                              userId,
                                                                                              statusId
                                                                                            }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/customUsers/${userId}/statuses/${statusId}/impact`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const getContactStatuses = createAsyncThunk('admin/getStatuses', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/customUsers/statuses/info`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get statuses'
    return rejectWithValue(errorMessage)
  }
})

export const getContactById = createAsyncThunk('customers/getContactById', async (userId, { rejectWithValue }) => {
  try {
    if (!userId) {
      return rejectWithValue('Failed to fetch customer')
    }
    const response = await apiRequest.get(`/customUsers/${userId}`)
    return response.data


  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const editContactById = createAsyncThunk('customers/editContactById', async ({
                                                                                      userId,
                                                                                      userData,
                                                                                    }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/customUsers/${userId}`, userData)
    return response.data

  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const getContactData = createAsyncThunk('customers/getContactData', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/customUsers/info/${userId}`)
    return response.data

  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const updateUserContactGroup = createAsyncThunk(
  'customers/updateUserContactGroup',
  async ({ userId, contactGroupId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(`/customUsers/${userId}/contact-group`, { contactGroupId })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to update contact group'
      return rejectWithValue(errorMessage)
    }
  }
)

export const getAssignToInfo = createAsyncThunk('users/getAssignToInfo', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/assignToInfo')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create custom user'
    return rejectWithValue(errorMessage)
  }
})

export const getContactProfile = createAsyncThunk('users/getContactProfile', async ({ userId }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/customUsers/${userId}/profile/statistics`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

// WS 2211251. Paid in full through outside financing: { lender, amount, fundedAt: 'YYYY-MM-DD' }.
export const recordFinancing = createAsyncThunk('users/recordFinancing', async ({ userId, body }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/customUsers/${userId}/financing`, body)
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error.response?.data?.error || error))
  }
})

// WS 2311820. The rep's answer to "is this client financing the fee?" (true / false).
export const setFinancingMark = createAsyncThunk('users/setFinancingMark', async ({ userId, financed }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/customUsers/${userId}/financing/mark`, { financed })
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error.response?.data?.error || error))
  }
})

export const changeUserCreator = createAsyncThunk('users/changeUserCreator', async ({ userId, newCreatorId }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/customUsers/${userId}/creator/${newCreatorId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to change user\'s creator'
    return rejectWithValue(errorMessage)
  }
})

export const getQCCallConfig = createAsyncThunk(
  'customer/getQCCallConfig',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/customUsers/${userId}/qc-call-config`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch QC call configuration'
      return rejectWithValue(errorMessage)
    }
  }
)

export const getAssigneesDropdown = createAsyncThunk(
  'customer/getAssigneesDropdown',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/customUsers/assignees/dropdown')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch assignees dropdown'
      return rejectWithValue(errorMessage)
    }
  }
)

export const addAssigneesToContact = createAsyncThunk(
  'customer/addAssigneesToContact',
  async ({ userId, assignees }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(`/customUsers/${userId}/assignees`, assignees)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to add assignees'
      return rejectWithValue(errorMessage)
    }
  }
)


export const getAcquisitionSourcesForFilterUtils = createAsyncThunk(
  'customer/getAcquisitionSourcesForFilterUtils',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/customUsers/acquisition-sources')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch acquisition sources'
      return rejectWithValue(errorMessage)
    }
  }
)

export const fetchAcquisitionSourceSummary = createAsyncThunk(
  'customer/fetchAcquisitionSourceSummary',
  async ({ leads = true, byCreator = false } = {}, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/customUsers/acquisition-sources/summary', {
        params: { leads, byCreator },
      })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch acquisition source summary'
      return rejectWithValue(errorMessage)
    }
  }
)

let leadDispositionsCache = null
let leadDispositionsCacheTimestamp = 0
let leadDispositionsInFlight = null
const LEAD_DISPOSITIONS_TTL_MS = 5 * 60 * 1000

export const invalidateLeadDispositionsCache = () => {
  leadDispositionsCache = null
  leadDispositionsCacheTimestamp = 0
  leadDispositionsInFlight = null
}

export const getLeadDispositions = createAsyncThunk(
  'customer/getLeadDispositions',
  async (_, { rejectWithValue }) => {
    try {
      const now = Date.now()
      if (leadDispositionsCache && now - leadDispositionsCacheTimestamp < LEAD_DISPOSITIONS_TTL_MS) {
        return leadDispositionsCache
      }
      if (!leadDispositionsInFlight) {
        leadDispositionsInFlight = apiRequest.get('/lead-dispositions')
          .then(response => {
            leadDispositionsCache = response.data
            leadDispositionsCacheTimestamp = Date.now()
            leadDispositionsInFlight = null
            return response.data
          })
          .catch(error => {
            leadDispositionsInFlight = null
            throw error
          })
      }
      return await leadDispositionsInFlight
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch lead dispositions'
      return rejectWithValue(errorMessage)
    }
  }
)

export const changeLeadDisposition = createAsyncThunk(
  'customer/changeLeadDisposition',
  async ({ userId, dispositionId, reason }, { rejectWithValue }) => {
    try {
      const url = `/customUsers/${userId}/dispositions/${dispositionId}`
      const response = reason
        ? await apiRequest.put(url, { reason })
        : await apiRequest.put(url)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to change disposition'
      return rejectWithValue(errorMessage)
    }
  }
)

const customerSlice = createSlice({
  name: 'customer',
  initialState: {
    // contacts: [],
    filters: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFilterList.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getFilterList.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.filters = action.payload
      })
      .addCase(getFilterList.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload
      })
  },
})

export default customerSlice.reducer
